module.exports = {
	"header": "Buying on __brand__ <small>Buyer features & services</small>",
	"paragraph1": "__brand__ gives you the opportunity to place bids on items and attend auction events all across the globe or even next door. Whether you’re on a busy schedule or it’s simply a rainy day and going outside to place bids doesn’t sound appealing to you in those conditions, __brand__ is there to help you.",
	"paragraph2": "You can participate and place bids in auction events using any computer or mobile device.",
	"bidLive": {
		"header": "Bid on items in real-time",
		"paragraph1": "Place bids on items in real-time using your computer or mobile device when the auction is taking place, anywhere in the World, as long as you have access to an internet connection."
	},
	"participate": {
		"header": "Participate in multiples auctions at the same time",
		"paragraph1": "You can watch and bid in multiple auction events at the same time if you so choose. There’s no limit to the number of auction events you can participate in simultaneously.",
		"paragraph2": "There are no limitations on our side either, the only limitation is your internet connection's available bandwidth. When participating in a real-time auction event, make sure you have a high speed and stable internet connectivity."
	},
	"absenteeBidding": {
		"paragraph1": "Should you be unable to be in front of your screen during the live event, you can still win items by leaving an absentee bid on them prior to the start of the event. If you indicate that your bid should be considered a maximum, our system will automatically re-bid for you and hopefully make you the highest bidder!"
	},
	"bidderDashboard": {
		"header": "Bidder Dashboard",
		"paragraph1": "You can review you past bids, absentee bids and items won, using the bidder dashboard."
	},
	"askQuestion": {
		"header": "Ask a question",
		"paragraph1": "Ask a question to the seller about the item or the event itself."
	},
	"notifications": {
		"header": "Notifications",
		"paragraph1": "Get notified prior to some events or when some items matching your interests get listed on __brand__."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/buying.json5
// module id = 1920
// module chunks = 6